import { useEffect, useRef } from "react";
import { Sparkles } from "lucide-react";

export const BenchName = ({ uid, name, setName, onSubmit, onCancel, busy, active }) => {
  const ref = useRef(null);
  useEffect(() => { if (active) ref.current?.focus(); }, [active]);
  return (
  <section data-testid="bench-name" className={`border p-6 transition-colors ${active ? "border-cyan-400/50 bg-cyan-400/5" : "border-slate-800 bg-slate-950/50 opacity-60"}`}>
    <p className="lab-label !text-cyan-300">Step 2 // Identify</p>
    <h2 className="mt-2 font-display text-lg md:text-xl uppercase tracking-widest text-slate-50">What is this object?</h2>
    <p data-testid="bench-name-uid" className="mt-1 font-mono text-xs tracking-widest text-slate-500">TAG {uid || "--"}</p>
    <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }} className="mt-4 flex flex-wrap gap-2">
      <input
        ref={ref}
        data-testid="bench-name-input"
        disabled={!active || busy}
        value={name}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Escape") onCancel(); }}
        placeholder="e.g. Feather, Rusty key, Pine cone"
        className="lab-input min-w-[240px] flex-1 text-lg"
      />
      <button data-testid="bench-generate-button" disabled={!active || busy || !name.trim()} className="lab-btn-primary">
        <Sparkles size={16} className={busy ? "animate-pulse" : ""} /> {busy ? "Consulting the Darkness..." : "Ask the Darkness (Enter)"}
      </button>
      {active && !busy && <button type="button" data-testid="bench-name-cancel" onClick={onCancel} className="lab-btn-ghost">Cancel</button>}
    </form>
  </section>
  );
};
